import m from "../../../../geodata/es2015/region/usa/scLow";
window.am4geodata_region_usa_scLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/scLow.js
// module id = null
// module chunks = 